import { motion, useScroll, useTransform } from "framer-motion";
import { useEffect, useState } from "react";

export default function Navbar() {
    const { scrollY } = useScroll();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const unsub = scrollY.on("change", (v) => setScrolled(v > 24));
        return () => unsub();
    }, [scrollY]);

    const opacity = useTransform(scrollY, [0, 80], [0, 1]);

    return (
        <motion.header
            data-testid="navbar"
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="fixed top-0 left-0 right-0 z-50"
        >
            <motion.div
                style={{ opacity }}
                className="absolute inset-0 backdrop-blur-xl bg-[#0a0a0c]/70 border-b border-white/5"
            />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8 h-16 flex items-center justify-between">
                <a href="#hero" data-testid="navbar-logo" className="flex items-center gap-2.5 group">
                    <span className="relative w-9 h-9 rounded-full bg-[#101014] border border-white/15 shadow-[0_0_0_1px_rgba(255,255,255,0.04),0_8px_30px_rgba(0,0,0,0.45)] flex items-center justify-center overflow-hidden">
                        <img
                            src="/app-logo.png"
                            alt="YolArkadaşım logosu"
                            className="w-full h-full object-cover rounded-full scale-[1.02]"
                            loading="eager"
                        />
                        <span
                            aria-hidden="true"
                            className="absolute inset-0 rounded-full ring-1 ring-[#00F0FF]/25 shadow-[inset_0_0_18px_rgba(0,240,255,0.15)]"
                        />
                    </span>
                    <span className="font-display font-semibold text-[15px] tracking-tight">
                        YolArkadaşım
                    </span>
                </a>

                <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
                    <a href="#ozellikler" className="hover:text-white transition-colors">Özellikler</a>
                    <a href="#vitrin" className="hover:text-white transition-colors">Vitrin</a>
                    <a href="#nasil" className="hover:text-white transition-colors">Nasıl çalışır</a>
                    <a href="#sss" className="hover:text-white transition-colors">SSS</a>
                </nav>

                <a
                    href="#"
                    data-testid="navbar-download-btn"
                    className={`btn-neon btn-cyan inline-flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full border border-[#00F0FF]/40 bg-[#00F0FF]/10 text-[#00F0FF] ${scrolled ? "" : ""}`}
                >
                    <span className="hidden sm:inline">Ücretsiz indir</span>
                    <span className="sm:hidden">İndir</span>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M5 12h14M13 6l6 6-6 6"/>
                    </svg>
                </a>
            </div>
        </motion.header>
    );
}
